<section class="container-fluid h-100">
  <!--p class="my-4 page-title">Portfólio</p-->

  <div
    id="vizContainer"
    class="h-100"
    style="display: flex; justify-content: center"
  >
    <app-tableau-embedded-viz
      class="viz"
      [vizUrl]="vizUrl"
      [token]="token"
      [parameters]="parameters"
    ></app-tableau-embedded-viz>
  </div>
</section>
